const trainslation = {
  Today: 'Today',
  Yesterday: 'Yesterday',
  'Last 7 days': 'Last 7 days',
  'Last Week': 'Last Week',
  'Last 30 days': 'Last 30 days',
  'Last Month': 'Last Month',

  'Service Uptime': 'Service Uptime',
  Maintanance: 'Maintenance',
  'Unplanned Outages': 'Unplanned Outages',
  'Operational Hours': 'Operational Hours',

  'Prevented Down Time': 'Prevented Down Time',
  'Preventive Action Taken': 'Preventive Action Taken',

  'Total Repair Time': 'Total Repair Time',
  'Number of Incidence': 'Number of Incidence',

  Cases: 'Cases',
  Open: 'Open',
  Ongoing: 'Ongoing',
  Closed: 'Closed',
  Incidents: 'Incidents',
  Requests: 'Requests',

  'Average Throughput': 'Average Throughput',

  'Network Map': 'Network Map',
  'Total Sites': 'Total Sites',
  'Online Sites': 'Online Sites',
  'Degraded Sites': 'Degraded Sites',

  Events: 'Events',
}

export default trainslation
